import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
// import axios from 'axios';
// import { PartnerSafeApi } from './EnvFiles';
// import { getStoredToken } from "../utils/getStoredToken";

const CreateServiceCenter = () => {
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [serviceCenterData, setServiceCenterData] = useState({
    descricao: '',
  });

  const [serviceCenterError, setServiceCenterError] = useState({
    descricao: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceCenterData((previous) => ({ ...previous, [name]: value }));

    setServiceCenterError((previous) => ({ ...previous, [name]: '' }));
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {};

    if (!serviceCenterData.descricao) {
      isValid = false;
      errors.descricao = 'Descrição é obrigatória';
    }

    setServiceCenterError(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Por favor, preencha o campo corretamente.');
      setSnackbarOpen(true);

      return;
    }

    console.log('DADOS DO CENTRO DE SERVIÇO:', serviceCenterData);
    setSnackbarSeverity('success');
    setSnackbarMessage('Centro de Serviço cadastrado com sucesso!');
    setSnackbarOpen(true);

    // TODO: INTEGRAÇÃO COM A API AINDA NÃO FINALIZADA
    // setIsLoading(true);

    // try {
    //   const response = await axios.post(
    //     `${PartnerSafeApi}/api/v1/Contratos/Cadastrar`,
    //     contractData,
    //     { headers: { Authorization: `Bearer ${token}` } }
    //   );

    //   setSnackbarSeverity('success');
    //   setSnackbarMessage('Contrato cadastrado com sucesso!');
    //   setSnackbarOpen(true);
    // } catch (error) {
    //   setSnackbarSeverity('error');
    //   setSnackbarMessage('Erro ao cadastrar contrato!');
    //   setSnackbarOpen(true);
    //   console.error('Erro ao cadastrar contrato:', error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        minHeight: '100vh',
        py: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, color: '#40685E', mb: 3 }}
      >
        Cadastro de Centro de Serviço
      </Typography>

      {isLoading ? (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: '100%', px: 4 }}>
          <TextField
            label="Descrição *"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            name="descricao"
            value={serviceCenterData.descricao}
            onChange={handleChange}
            error={!!serviceCenterError.descricao}
            helperText={serviceCenterError.descricao}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Cadastrar Centro de Serviços
            </Button>
          </Box>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateServiceCenter;
